import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const tagService = {
    getAll,
    getWooTag
};

function getAll(page, perPage) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    const _pageNum = page || 1;
    const _perPage = perPage || Config.pagination.limit;

    return fetch(Config.api.basepath+`/tags?page=${_pageNum}&per-page=${_perPage}`, requestOptions)
        .then(handleResponse)
        .then(
            posts => {
                let pages = parseInt(posts.total / posts['per-page']);
                pages = posts.total > ( pages * posts['per-page'] ) ? pages + 1 : pages;
                posts.pages = pages;

                return posts;
            },
            error => {
                return {error: 'Fetch Post Error. Service Unavailable.'};
            }
        );
}

function getWooTag() {


    const baseUrl = window.location.origin;
    // Fetch "new" tag
    const newTagRequestData = {
        url: `${baseUrl}/wp-json/wc/v3/products/tags`,
        method: 'GET'
    };
    const newTagHeaders = oauthFunction().toHeader(oauthFunction().authorize(newTagRequestData));

    return fetch(newTagRequestData.url, {
        method: newTagRequestData.method,
        headers: newTagHeaders
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch "new" tag');
        }
        return response.json();
    })

}

function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            let error = (data.error && data.error.message) || response.statusText;

            if( data.error && data.error.code === 11000){
                error = 'Menu already exists.';
            }
            
            return Promise.reject(error);
        }

        return data;
    });
}
